import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'app/store';
import { selectAuth } from 'app/store/authSlice';
import { isEligibleForPasskeyPrompt } from 'app/auth/passkeyPromptSession';

function MobileLanding(): JSX.Element | null {
  const { user } = useAppSelector(selectAuth);

  // SEE-214: prompt eligible users to enroll a passkey once per login session
  // before dropping them on the mobile home. The fast path is the redirect in
  // MobileSignIn right after password login; this covers every other entry
  // (reload, deep link). PasskeyPrompt records the per-user session guard on
  // mount, preventing a redirect loop when it sends the user back through here.
  if (isEligibleForPasskeyPrompt(user)) {
    return <Navigate to="/setup-passkey" replace />;
  }

  return <Navigate to="/mobile-demo" replace />;
}

export default MobileLanding;
